/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_StudioInputs */

const en_mk_nav_studio = /** @type {(inputs: Mk_Nav_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const id_mk_nav_studio = /** @type {(inputs: Mk_Nav_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Mk_Nav_StudioInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_studio = /** @type {((inputs?: Mk_Nav_StudioInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_StudioInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_studio(inputs)
	return en_mk_nav_studio(inputs)
});